import ArchiveGallery from "./ArchiveGallery";

function WoodMural() {
  return (
    <ArchiveGallery
      category="wood"
      showCollectionFilter={false}
      emptyTitle="No wood murals found in this section."
    />
  );
}

export default WoodMural;
